// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"85f8c7a9","807":"a3d9bbc6","845":"70c76640"}[chunkId] + ".chunk.js";
};